import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

import { devices } from './imports/utils';

export default {
  data() {
    return {
      isDevice: devices(),
    }
  },
  methods: {
    followMouse(e, el, reverse = false) {
      let xTo = gsap.quickTo(el, "x", { duration: 2, ease: "power3" }),
        yTo = gsap.quickTo(el, "y", { duration: 0.4, ease: "power3" });

      let x = 0.05 * (window.innerWidth / 2 - e.x);
      let y = 0.05 * (window.innerHeight / 2 - e.y);

      if (reverse) {
        x = -x;
        y = -y;
      }

      xTo(x);
      yTo(y);
    },
  },
  mounted() {
    //////////////////////////////////////////////////////////////////////////////// Collection list
    const collectionsList = gsap.utils.toArray('.collections-list');
    if (collectionsList.length) {
      const followMouseEls = gsap.utils.toArray(".collections-list li");
      if (followMouseEls.length) {

        followMouseEls.forEach(el => {
          if (!this.isDevice) {
            el.addEventListener("mousemove", (e) => {
              this.followMouse(e, el);
            });
          }
        });
      }
    }

    //////////////////////////////////////////////////////////////////////////////// Collection inner
    const collectionPhotos = gsap.utils.toArray('.collection-inner-photos li a');
    if (collectionPhotos.length) {

      collectionPhotos.forEach((photo, index) => {
        let y = 100;

        if ((index + 1) % 2 === 0) {
          y = 50;
        }

        if ((index + 1) % 3 === 0) {
          y = 150;
        }

        gsap.to(photo, {
          scrollTrigger: {
            trigger: photo,
            start: "0% 90%",
            end: "100% 10%",
            // toggleActions: 'play none none none',
            scrub: 2.5,
            // markers: true
          },
          y: `-${y}px`
        });
      });

      ////////////////////////////////////// Follow mouse
      const followMouseEls = gsap.utils.toArray(".collection-inner-photos li");
      if (followMouseEls.length) {
        if (!this.isDevice) {
          window.addEventListener("mousemove", (e) => {
            this.followMouse(e, followMouseEls)
          }, { passive: true });
        }
      }
    }

    //////////////////////////////////////////////////////////////////////////////// Bespoke list
    const bespokeList = gsap.utils.toArray('.bespoke-list');
    if (bespokeList.length) {
      const followMouseEls = gsap.utils.toArray(".bespoke-list li");
      if (followMouseEls.length) {

        followMouseEls.forEach(el => {
          if (!this.isDevice) {
            el.addEventListener("mousemove", (e) => {
              this.followMouse(e, el, true);
            });
          }
        });
      }
    }
  }
}